// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3Jx9IPBPafe_VD-7PQQGd-","contentCenter":"_3cmMcimvS-tx6n2tckJg7X","item":"_1C6RV0Md0AmKLedvJJIwMm"};